import type { OrgInviteTokenPayload } from '~~/shared/organizations/inviteToken'

/** The decoded (NOT verified — see `shared/organizations/inviteToken.ts`) invite payload. */
export type DecodedOrgInviteToken = OrgInviteTokenPayload

function decodeBase64Url(input: string) {
  const normalized = input.replace(/-/g, '+').replace(/_/g, '/')
  const padded = normalized.padEnd(normalized.length + (4 - normalized.length % 4) % 4, '=')
  return atob(padded)
}

export function decodeOrgInviteToken(token: string | null | undefined): DecodedOrgInviteToken | null {
  if (!token) return null
  const parts = token.split('.')
  if (parts.length !== 3) return null
  try {
    const payload = JSON.parse(decodeBase64Url(parts[1]!)) as Partial<DecodedOrgInviteToken>
    if (
      payload.typ !== 'org_invite' ||
      typeof payload.invite_id !== 'string' ||
      typeof payload.code !== 'string' ||
      typeof payload.org_id !== 'string' ||
      typeof payload.org_name !== 'string' ||
      typeof payload.role !== 'string'
    ) return null
    return payload as DecodedOrgInviteToken
  } catch {
    return null
  }
}
